'use client';
import { LineChart } from '@mnd-frontend/charts';
import { useState } from 'react';
import { useReportTracking, useReportTranslation } from '../../hooks';
import { GraphCaption, HitsModal, type HitsModalDetails, SkeletonBarChart } from '../common';
import { GraphContainer } from '../common/GraphContainer';
import { ScrollContainer } from '../common/ScrollContainer';

export const ShareOfVoiceOverTimeGraph = ({
  data,
  mappings,
  loading,
  groups,
}: {
  data: Record<string, string | number>[];
  mappings: { name: string; dataKey: string; color?: string; searchProfileIds: string[] }[];
  groups: { id: string }[];
  loading: boolean;
}) => {
  const [details, setDetails] = useState<{
    searchProfileIds: string[] | null;
    details: HitsModalDetails;
  } | null>(null);

  const { t } = useReportTranslation();
  const { track } = useReportTracking();

  return (
    <ScrollContainer minWidth="35rem">
      <GraphContainer data-testid="share-of-voice-over-time-graph">
        {!loading && (
          <>
            <GraphCaption>{t('reports_number_of_mentions')}</GraphCaption>
            <LineChart
              groups={groups}
              data={data}
              mappings={mappings}
              autoSortData={false}
              onClick={d => {
                track({
                  event: 'Brand Reports: Clicked Share of voice over time graph',
                });
                const tickData = data[d.tick];
                setDetails({
                  searchProfileIds: mappings[0].searchProfileIds,
                  details: {
                    label: mappings[0].name,
                    startAt: tickData.startAt as string,
                    endAt: tickData.endAt as string,
                  },
                });
              }}
            />
          </>
        )}
        {loading && <SkeletonBarChart />}
        {details && (
          <HitsModal
            onClose={() => setDetails(null)}
            details={details.details}
            searchProfileIds={details.searchProfileIds}
          />
        )}
      </GraphContainer>
    </ScrollContainer>
  );
};
